'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RelationalComponent } from './component';
import { FormsModule } from '@angular/forms';
import { LKIcon } from '../icon/module';
import { KeyboardNavigation } from '../keyboardnavigation/module';
import { LKAutoComplete } from '../autocomplete/module';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule,
    LKIcon,
    LKAutoComplete,
    KeyboardNavigation
  ],
  declarations: [
    RelationalComponent,
  ],
  exports     : [
    RelationalComponent,
  ]
})
export class LKRelational {
}
